import React from 'react';
import Loadable from 'react-loadable';
import LoadableLoading from 'components/LoadableLoading';
import { getDefectsShort, getGroupApplicationReportList, getPositions, getRealEstatesShort } from './api';
import { EReports } from './interfaces';

export const path = '/reports/group-application';

const PageGroupApplicationReports: React.FC = (props) => {
  const GroupApplicationReports = Loadable.Map({
    loader: {
      page: () => import('./page'),
      positions: getPositions,
      users: () => getGroupApplicationReportList(EReports.USER),
      realEstates: getRealEstatesShort,
      defects: getDefectsShort,
    },
    loading: LoadableLoading,
    render(loaded, loadedProps: {}) {
      const Page = loaded.page.default;

      return <Page {...loadedProps} {...loaded} />;
    },
  });

  return <GroupApplicationReports {...props} />;
};

export default PageGroupApplicationReports;
